module.exports = __webpack_public_path__ + "static/media/ic-arrow-back.51fc063d.svg";